import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import { AppHeader } from '../AppHeader';
import { AppFooter } from '../AppFooter';
import FloatingComponents from '../../ui/FloatingComponents/FloatingComponents';
import styles from './Layout.module.scss';

export const Layout: React.FC = () => {
  const { pathname } = useLocation();

  // 路由切换时滚动到页面顶部
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <div className={styles.layout}>
      <AppHeader />
      <main className={styles.main}>
        <Outlet />
      </main>
      <AppFooter />
      
      {/* 悬浮组件 - 只显示返回顶部 */}
      <FloatingComponents 
        showBackToTop={true}
        showCustomerService={false}
        backToTopThreshold={300}
      />
    </div>
  );
};